import { render, staticRenderFns } from "./SickRelativesBlock.vue?vue&type=template&id=09eb962b&lang=pug&"
import script from "./SickRelativesBlock.vue?vue&type=script&lang=js&"
export * from "./SickRelativesBlock.vue?vue&type=script&lang=js&"
import style0 from "./SickRelativesBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports